import React, { useState, useMemo } from "react";
import { sanitize } from "./sanitizeHtml";
import { splitQuotedHtml, splitQuotedText } from "./quote";
import styles from "./Inbox.module.css";

/**
 * A message body with Gmail's trimmed-quote behaviour: what the sender wrote
 * is shown; the quoted earlier messages sit behind a "•••" pill.
 */
const MessageBody = ({ html, text }) => {
  const [showQuoted, setShowQuoted] = useState(false);
  const parts = useMemo(
    () => (html ? splitQuotedHtml(sanitize(html)) : splitQuotedText(text)),
    [html, text]
  );

  return (
    <>
      {html
        ? <div dangerouslySetInnerHTML={{ __html: parts.main }} />
        : <pre className={styles.plainText}>{parts.main}</pre>}
      {parts.quoted && (
        <>
          <button
            type="button"
            className={styles.trimBtn}
            onClick={() => setShowQuoted(v => !v)}
            title={showQuoted ? "Hide expanded content" : "Show trimmed content"}
            aria-expanded={showQuoted}
            aria-label={showQuoted ? "Hide expanded content" : "Show trimmed content"}
          >
            •••
          </button>
          {showQuoted && (html
            ? <div className={styles.quotedContent} dangerouslySetInnerHTML={{ __html: parts.quoted }} />
            : <pre className={`${styles.plainText} ${styles.quotedContent}`}>{parts.quoted}</pre>)}
        </>
      )}
    </>
  );
};

export default MessageBody;
